import React, { useState, useEffect } from "react";
import axios from "axios";

import { useNavigate, useParams } from "react-router-dom";

import Spinner from "./Spinner/Spinner"
import QuotesList from "./QuotesList";
import SingleQuote from "./SingleQuote";

const Topics = () => {
  let navigate = useNavigate();

  const [topics, setTopics] = useState([]);

  const [quotes, setQuotes] = useState([]);
  const [keywords, setKeywords] = useState([]);

  const [total, setTotal] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [perPage, setPerPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);

  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_STOIC_KEYWORDS}`
      );
      setTopics(response.data.map(a => a.word));
      setLoading(false);
    } catch (error) {
      return error;
    }
  };

  const fetchQuotes = async (pageNumber) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_STOIC_SEARCH}/${query}?page=${pageNumber}&limit=18`
      );
      setQuotes(response.data.results);
      setKeywords(response.data.results[0]["keywords"])
      setTotal(response.data.total_results);
      setTotalPages(response.data.total_pages);
      setPerPage(response.data.per_page);
      setCurrentPage(response.data.page);
      setLoading(false);
    } catch (error) {
      return error;
    }
  };

  const handleClick = (topic) => {
    navigate(`/topics/${topic}`)
  }

  const { query } = useParams()

  useEffect(() => {
    if (query) {
      fetchQuotes(1);
    } else {
      fetchData();
    }
  }, [query]);

  if(loading) {
    return (<div><Spinner/></div>)
  } else {

    return (
      <div>
        {query ? 
          quotes.length > 1 ? 
            (<div className="mt-5">
              <QuotesList
                quotes={quotes}
                total={total}
                totalPages={totalPages}
                perPage={perPage}
                currentPage={currentPage}
                fetchQuotes={fetchQuotes}
                loading={loading}
                query={query}
              />
            </div>) 
          : 
            (
              <div>
                
                <SingleQuote singleQuote={quotes[0]} singleQuoteKeywords={keywords}/>
              </div>
            )
          
          : 
          <div className="flex flex-col">
            <h1 className="mt-6 md:my-2 text-center text-2xl font-bold italic">
              Keywords calculated in order of importance: 
            </h1>
            <div className="my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
              <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                <table className="text-center min-w-full divide-y divide-gray-200">
                  <thead>
                    <tr>
                      <th className="px-6 py-6 bg-gray-50 text-lg leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Ranking
                      </th>
                      <th className="px-6 py-6 bg-gray-50 text-lg leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Keyword
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                  {topics.map((topic, index) => (
                    <tr key={index} onClick={() => {handleClick(topic)}} className={`hover:bg-purple-100 cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}>
                      <td className="px-6 py-4 whitespace-no-wrap text-lg leading-5 text-gray-500">
                        {index + 1}
                      </td>
                      <td className="flex justify-between underline px-6 py-4 whitespace-no-wrap text-lg leading-5 font-medium text-gray-900">
                          <div></div>
                          {topic} 
                          <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                          </svg>
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
};

export default Topics;
